import { spec, validators } from 'utils/validation'

const { any } = validators

export const formModel = (_state, { initialValues = {} }) => ({
  event: {
    initialValue: initialValues.eventId,
    spec: spec.flow(any.required),
  },

  tournamentId: {
    initialValue: initialValues.tournamentId || null,
    spec: spec.flow(),
  },

  athleteId: {
    initialValue: initialValues.athleteId || null,
    spec: spec.flow(),
  },

  score: {
    initialValue: initialValues.score ?? 0,
    spec: spec.flow(),
  },

  condition: {
    initialValue: initialValues.triggerCondition,
    spec: spec.flow(),
  },

  outcome: {
    initialValue: initialValues.outcome ?? '',
    spec: spec.flow(),
  },

  description: {
    initialValue: initialValues.description || '',
    spec: spec.flow(),
  },

  binaryWinner: {
    initialValue: initialValues.binaryWinner,
    spec: spec.flow(),
  },

  category: {
    initialValue: initialValues.category,
    spec: spec.flow(any.required),
  },

  subCategory: {
    initialValue: initialValues.subCategory,
    spec: spec.flow(any.required),
  },
})
